import { metricsStore } from '@globalStore/metricsStore';
import { exclusiveFrustrationSignalDimension } from '@src/globalStore/limitationStore/defaultExcludes';
import { FLOW_HIDDEN_STATIC_DIMENSIONS } from '@src/utils/dimension/appDimensionHelper';

export const createFlowPresetLimitations = () => {
  const { flowConfigMeta } = metricsStore.getState();
  if (!flowConfigMeta) return {};
  const flowLimitations = Object.keys(flowConfigMeta).reduce(
    (acc, flowId) => {
      acc[`flow-${flowId}`] = getFlowPresetLimitation(flowId);
      return acc;
    },
    {} as Record<string, ReturnType<typeof getFlowPresetLimitation>>,
  );
  return flowLimitations;
};

export const getFlowPresetLimitation = (flowId: number | string) => {
  const { metricsCategoryKeys } = metricsStore.getState();
  const currentFlowMeta = metricsStore.getState()?.flowConfigMeta?.[flowId];

  if (currentFlowMeta?.identifier) {
    return {
      context: {
        type: 'flow',
        id: flowId,
      },
      metrics: {
        excludeTypes: [],
        excludeKeys: [],
        excludeCategories: [
          metricsCategoryKeys.ECO_ENGAGEMENT,
          metricsCategoryKeys.ECO_QOE,
          metricsCategoryKeys.ECO_AUDIENCE,
          metricsCategoryKeys.ECO_SERVICE_PERFORMANCE,
          metricsCategoryKeys.ECO_APP_USER_EXPERIENCE,
          metricsCategoryKeys.ECO_USER_DEFINED_METRICS,
          metricsCategoryKeys.ECO_WEB_USER_EXPERIENCE,
        ],
        config: {
          createCustomMetric: false,
          createFlowMetric: false,
          showPercentile: true,
          showFlow: false,
        },
      },
      dimensions: {
        hiddenKeys: [...FLOW_HIDDEN_STATIC_DIMENSIONS],
        excludeCategories: [...exclusiveFrustrationSignalDimension],
      },
      dimensionPanel: {},
      summaryMetricPanel: {},
    };
  }

  return undefined;
};
